/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_DeletedInputs */

const en_admin_roles_deleted = /** @type {(inputs: Admin_Roles_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role deleted`)
};

const zh_admin_roles_deleted = /** @type {(inputs: Admin_Roles_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色已删除`)
};

/**
* | output |
* | --- |
* | "Role deleted" |
*
* @param {Admin_Roles_DeletedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_deleted = /** @type {((inputs?: Admin_Roles_DeletedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_DeletedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_deleted(inputs)
	return zh_admin_roles_deleted(inputs)
});
export { admin_roles_deleted as "admin.roles.deleted" }